// This component has been autogenerated with 'generate:components' script
import type { IconProps } from 'icons/types/Icon.types'
import { DEFAULT_ICON_COLOR, DEFAULT_ICON_SIZE } from 'icons/utils/constants'
import { cx } from 'utils/cx'

import styles from 'icons/Icon.module.scss'

export const IconPinSelected = ({
	alt,
	className,
	color = DEFAULT_ICON_COLOR,
	height = DEFAULT_ICON_SIZE,
	lang,
	width = DEFAULT_ICON_SIZE,
	rotateRtl,
}: IconProps): React.ReactNode => {
	const computedClassName = cx(
		styles[`icon-${color}`],
		rotateRtl && styles['rotate-rtl'],
		className
	)

	return (
		<svg
			width={width}
			height={height}
			aria-hidden={alt ? undefined : 'true'}
			className={computedClassName}
			data-testid='pin-selected'
			xmlns='http://www.w3.org/2000/svg'
		>
			{alt && <title lang={lang}>{alt}</title>}
			<path
				fill='#131313'
				fillRule='evenodd'
				d='M20 0C12.446 0 5.36 4.384 1.95 11.17c-3.699 7.362-2.07 16.85 4.318 25.332.204.3 12.544 18.724 12.544 18.724L20.001 57l1.188-1.774 12.505-18.67c6.427-8.536 8.056-18.024 4.357-25.385C34.64 4.384 27.556 0 20 0m0 32c6.627 0 12-5.373 12-12S26.627 8 20 8 8 13.373 8 20s5.373 12 12 12'
				clipRule='evenodd'
			/>
		</svg>
	)
}
